export interface StatsCard {
  label: string
  count: number
  key: string
}

export const ACTIVITY_RECEIVED: StatsCard = {
  label: 'Activity Received',
  count: 0,
  key: 'RECEIVED'
}

export const IN_PROGRESS: StatsCard = {
  label: 'In Progress',
  count: 0,
  key: 'IN_PROGRESS'
}

export const PENDING_WITH_ER: StatsCard = {
  label: 'Pending with ER',
  count: 0,
  key: 'PENDING_WITH_EMPLOYER'
}

export const PENDING_WITH_DEPARTMENT: StatsCard = {
  label: 'Pending with Department',
  count: 0,
  key: 'PENDING_WITH_DEPT'
}

export const PENDING_WITH_EE: StatsCard = {
  label: 'Pending with EE',
  count: 0,
  key: 'PENDING_WITH_EMPLOYEE'
}

export const COMPLETED: StatsCard = {
  label: 'Completed',
  count: 0,
  key: 'COMPLETED'
}

export const QUERIES_RECEIVED: StatsCard = {
  label: 'Queries Received',
  count: 0,
  key: 'RECEIVED'
}

export const QUERY_RECEIVED: StatsCard = {
  label: 'Query Received',
  count: 0,
  key: 'RECEIVED'
}
